import "core-js/modules/es.array.push.js";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { trackHelpCenterPayoutIaCtaClick } from "@faire/web-api/events/helpCenter/click/payoutIaCta";
import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import { path as getSelfServeRecommendedArticleRoute } from "@faire/web-api/routes/support/self-serve/recommended-article";
import React from "react";
import { UpdatePayoutsIA } from "./instantAnswersComponents/payments/UpdatePayoutsIA";
export var updatePayouts = function updatePayouts(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _getPrimaryCTA2;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : _getPrimaryCTA2.onClick;
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UPDATE_PAYOUTS_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return UPDATE_PAYOUTS_DESCRIPTION(context);
    }
  };
};
var UPDATE_PAYOUTS_TITLE = function UPDATE_PAYOUTS_TITLE(strictLocalize) {
  return strictLocalize({
    id: "0tz2zv",
    defaultMessage: [{
      "type": 0,
      "value": "Change your payout option"
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  return {
    label: strictLocalize({
      id: "ho19rL",
      defaultMessage: "Update payout option"
    }),
    onClick: function onClick(history) {
      var _getBrandToken, _context$brandOrder$b, _context$brandOrder, _context$brandOrder$b2;
      payoutUpdateOptionOnClick(history);
      trackHelpCenterPayoutIaCtaClick((_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "", (_context$brandOrder$b = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b2 = _context$brandOrder.brand_order) === null || _context$brandOrder$b2 === void 0 ? void 0 : _context$brandOrder$b2.token) !== null && _context$brandOrder$b !== void 0 ? _context$brandOrder$b : "");
    }
  };
};
var UPDATE_PAYOUTS_DESCRIPTION = function UPDATE_PAYOUTS_DESCRIPTION(context) {
  var brand = context.brand;
  return /*#__PURE__*/React.createElement(UpdatePayoutsIA, {
    brand: brand
  });
};
var payoutUpdateOptionOnClick = function payoutUpdateOptionOnClick(history) {
  history === null || history === void 0 ? void 0 : history.push(getSelfServeRecommendedArticleRoute({
    payout_update_modal: "1"
  }));
};